function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H24V24H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M24409.154 19136.008a5.721 5.721 0 0 1-4.312 0 3.429 3.429 0 1 1-3.547-5.672 5.665 5.665 0 0 1 1.662-3.66 5.8 5.8 0 0 1 .947-.768 3.429 3.429 0 1 1 6.188 0 5.742 5.742 0 0 1 2.607 4.424 3.429 3.429 0 1 1-3.545 5.674zm-2.156-.721a4.583 4.583 0 0 0 1.473-.242 3.43 3.43 0 0 1 3.063-4.9 4.575 4.575 0 0 0-2.1-3.3 3.428 3.428 0 0 1-4.863 0 4.579 4.579 0 0 0-2.105 3.3 3.43 3.43 0 0 1 3.064 4.9 4.58 4.58 0 0 0 1.47.242z",
  transform: "translate(-24394.996 -19117)"
});

function SvgIconManifacturers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManifacturers);
export default __webpack_public_path__ + "static/media/icon_manifacturers.51bea38a.svg";
export { ForwardRef as ReactComponent };